/* eslint-disable camelcase */
import {
    getFormStepByName,
    getHotlineNumbers,
    getTrackingFixnetFootprint,
    normalizeTrackingPayloadName,
    PageViewTrackingData,
    TrackingAvcForm,
    TrackingCableBtx,
    TrackingErrorType,
    TrackingFixnetError,
    TrackingFixnetFlowType,
    TrackingFormStepName,
    TrackingPageType,
    TrackingPlatformType,
    TrackingSelectedOption,
    TrackingSiteArea,
    TrackingTargetAudience,
    TrackToggleOption,
} from '@vfde-sails/tracking';
import {
    getAvcPageLevels,
    getBusinessTransactionType,
    getFormStatus,
    getLoginStatus,
    getSiteArea,
    getTrackingOrder,
    getTrackingOrderProduct,
    getTrackingProduct,
    getTvConnection,
    pageLevels,
} from './util';
import { ProductType } from '../enum';
import { JarvisMarketability, JarvisOption, JarvisProduct, JarvisTvProduct } from '@vfde-sails/availability';
import { ProductAvailability } from '../container/AddressValidation/interface';

export const getPageViewTrackingData = (
    product: JarvisProduct,
    productType: ProductType,
    isLoggedIn: boolean,
    tvConnect?: JarvisTvProduct,
): PageViewTrackingData => {
    const result: PageViewTrackingData = {
        page_levels: pageLevels,
        page_type: TrackingPageType.ProductDetail,
        login_status: getLoginStatus(isLoggedIn),
        site_area: getSiteArea(productType),
        platform_type: TrackingPlatformType.Responsive,
        flow_type: TrackingFixnetFlowType.TvFlow,
        business_transaction_type: getBusinessTransactionType(productType),
        line_of_customer: TrackingTargetAudience.Consumer,
        oOrder: getTrackingOrder(product, productType, tvConnect),
    };

    return result;
};

export const getTrackingAvcForm = (
    product: JarvisProduct,
    type: ProductType,
    step: TrackingFormStepName | 'outcome',
    isLoggedIn: boolean,
    availability: ProductAvailability,
    marketability?: JarvisMarketability,
) => {
    const result: Partial<TrackingAvcForm> = {
        business_transaction_type: TrackingCableBtx.CableDigitalTv,
        flow_type: TrackingFixnetFlowType.TvFlow,
        hotline_numbers: getHotlineNumbers(),
        line_of_customer: TrackingTargetAudience.Consumer,
        login_status: getLoginStatus(isLoggedIn),
        site_area: TrackingSiteArea.Cable,
        page_levels: getAvcPageLevels(step),
        page_type: TrackingPageType.Availability,
        platform_type: TrackingPlatformType.Responsive,
        selected_product: getTrackingProduct(product, type),
    };

    if (step !== 'outcome') {
        result.form_type = 'availability';
        result.form_name = 'product availability check';
        result.form_step = getFormStepByName(step);
        result.form_step_name = step;
        result.form_status = getFormStatus(step);
    }

    if ((step === TrackingFormStepName.Complete || step === 'outcome') && marketability) {
        result.product_footprint = getTrackingFixnetFootprint(marketability.providerType);
        result.recommended_products = [ product.id ];
        result.selected_product_available = availability.cableTv;
        result.self_installation_available = marketability.isSelfInstall;
        result.tv_connection_type = getTvConnection(marketability);
    }

    return result;
};

export const getGigakombiTrackingData = (isGigakombi: boolean, option?: JarvisOption): TrackingSelectedOption => {
    const actionType = isGigakombi
        ? TrackToggleOption.Selected
        : TrackToggleOption.Removed;

    return {
        [actionType]: [
            getTrackingOrderProduct(option),
        ],
    };
};

export const getTrackingErrorData = (message: string, type: TrackingErrorType, status?: number): TrackingFixnetError => ({
    error_action: 'displayed',
    error_type: type,
    error_message: normalizeTrackingPayloadName(message),
    error_code: status?.toString(),
});
